<div class="row" [class.px-3]="quickFilterSpacing" *ngIf="_tableDisplayConfig">


  <div class="col-12">


    <form [formGroup]="columnFilterForm">

      <div class="row" [class.my-3]="rowSpacing" [class.my-2]="quickFilterSpacing">

        <ng-container *ngFor="let column of tableConfig?.columns">

          <div
            class="col-12 py-2"
            [class.col-sm-6]="!compactView"
            [class.col-sm-4]="compactView"
            *ngIf="
              (column.filterable && column.filter_visible && !(globalFilter?.[column.name]) && !quickFilterOnly) ||
              (column.filterable && column.filter_visible && !(globalFilter?.[column.name]) && (quickFilterOnly && column.quick_filter))
          ">

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.STRING  || column.type === TableConfigColumnTypeEnum.MULTI_LANGUAGE_ATTRIBUTE_DATA">
              <app-form-group
                [formControl]="$any(columnFilterForm.get(column.name))"
                type="text"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) | translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
                [class.custom-compact-input]="compactView"
              ></app-form-group>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.BOOL">
              <app-multi-select-with-static-options
                [inline]="inlineInput"
                [small]="smallInput"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="false"
                [name]="column.name"
                [selectOptions]="[
                { value: 'enums.bool.1' | translate,key: '1'},
                { value: 'enums.bool.0' | translate,key: '0'}
                ]"
              ></app-multi-select-with-static-options>
            </ng-container>

            <ng-container
              *ngIf="[TableConfigColumnTypeEnum.MODEL_STATE_ENUM , TableConfigColumnTypeEnum.MODEL_STATE_STATE_MACHINE].includes($any(column.type))">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="ModelStateEnum"
                translateKey="modelStateEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.COUNTRY_CODE_ISO_ALPHA_3_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="CountryCodeISOAlpha3Enum"
                translateKey="countryCodeISOAlpha3Enum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.INT">
              <app-int-filter
                *ngIf="$any(columnFilterForm.get(column.name))"
                [formControlName]="column.name"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) | translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [inline]="inlineInput"
                [small]="smallInput"
                [class.custom-compact-input]="compactView"
              ></app-int-filter>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.MONEY">
              <app-money-filter
                *ngIf="$any(columnFilterForm.get(column.name))"
                [formControlName]="column.name"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) | translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [inline]="inlineInput"
                [small]="smallInput"
                [class.custom-compact-input]="compactView"
              ></app-money-filter>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.DATE">
              <app-date-filter
                *ngIf="$any(columnFilterForm.get(column.name))"
                [formControlName]="column.name"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) | translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [inline]="inlineInput"
              ></app-date-filter>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.CARBON_IMMUTABLE && ['cancellable_by_customer_until'].includes(column.name)">
              <app-static-date-range-filter
                *ngIf="$any(columnFilterForm.get(column.name))"
                [formControlName]="column.name"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [inline]="inlineInput"
                [autofillDayRange]="10"
                [autofillEndDate]="true"
              ></app-static-date-range-filter>
            </ng-container>


            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.CARBON_IMMUTABLE && !['cancellable_by_customer_until'].includes(column.name)">
              <app-date-filter
                *ngIf="$any(columnFilterForm.get(column.name))"
                [formControlName]="column.name"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) | translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [inline]="inlineInput"
              ></app-date-filter>

            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.ARRAY && !['sales_channels', 'online_shop_filter', 'icons', 'characteristics', 'reasons_for_difference', 'event_characteristics'].includes(column.name) ">
              <code>{{column.type}} filter not implemented on column {{column.name}} </code>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.RELATION_UUID_ATTRIBUTE_DATA">

              <div class="alert alert-warning" *ngIf="![''].includes(column.name)">
                <code>{{column.type}} filter not implemented on column {{column.name}}) </code>
              </div>

            </ng-container>

            <app-multi-select-enum
              *ngIf="column.type === TableConfigColumnTypeEnum.RESOURCES_SERVICE_PROVIDER_TYPE_ENUM"
              [inline]="inlineInput"
              [small]="smallInput"
              [name]="column.name"
              [formControl]="$any(columnFilterForm.get(column.name))"
              [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
              [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
              [multi]="true"
              [enum]="ServiceProviderTypeEnum"
              translateKey="serviceProviderTypeEnum"
            ></app-multi-select-enum>

            <app-multi-select-enum
              *ngIf="column.type === TableConfigColumnTypeEnum.EVENTMANAGEMENT_EVENT_EVENT_PHASE_ENUM"
              [inline]="inlineInput"
              [small]="smallInput"
              [name]="column.name"
              [formControl]="$any(columnFilterForm.get(column.name))"
              [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
              [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
              [multi]="true"
              [enum]="EventPhaseEnum"
              translateKey="eventPhaseEnum"
            ></app-multi-select-enum>

            <app-multi-select-enum
              *ngIf="column.type === TableConfigColumnTypeEnum.EVENTMANAGEMENT_EVENT_EVENT_STATE_ENUM"
              [inline]="inlineInput"
              [small]="smallInput"
              [name]="column.name"
              [formControl]="$any(columnFilterForm.get(column.name))"
              [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
              [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
              [multi]="true"
              [enum]="EventStateEnum"
              translateKey="eventStateEnum"
            ></app-multi-select-enum>

            <app-multi-select-enum
              *ngIf="column.type === TableConfigColumnTypeEnum.EVENTMANAGEMENT_EVENT_REVENUE_COST_CENTER_ENUM"
              [inline]="inlineInput"
              [small]="smallInput"
              [name]="column.name"
              [formControl]="$any(columnFilterForm.get(column.name))"
              [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
              [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
              [multi]="true"
              [enum]="EventRevenueCostCenterEnum"
              translateKey="eventRevenueCostCenterEnum"
            ></app-multi-select-enum>

            <!--              *ngIf="column.type === TableConfigColumnTypeEnum.resources_service_provider_inquiry_state_machine"-->

            <app-multi-select-enum
              *ngIf="column.type === TableConfigColumnTypeEnum.RESOURCES_SERVICE_PROVIDER_INQUIRY_STATE_MACHINE"
              [inline]="inlineInput"
              [small]="smallInput"
              [name]="column.name"
              [formControl]="$any(columnFilterForm.get(column.name))"
              [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
              [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
              [multi]="true"
              [enum]="ServiceProviderInquiryStateEnum"
              translateKey="serviceProviderInquiryStateEnum"
            ></app-multi-select-enum>

            <!--            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.RELATION_UUID_ATTRIBUTE_DATA && column.name === 'room_ids'">-->
            <!--              <app-multi-select-with-service-->
            <!--                [small]="smallInput"-->
            <!--                [searchOnField]="'internal_title'"-->
            <!--                [inline]="inlineInput"-->
            <!--                [service]="roomService"-->
            <!--                [formControl]="$any(columnFilterForm.get(column.name))"-->
            <!--                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"-->
            <!--              ></app-multi-select-with-service>-->
            <!--            </ng-container>-->

            <div class="alert alert-warning small"
                 *ngIf="![
                          TableConfigColumnTypeEnum.CARBON_IMMUTABLE,
                          TableConfigColumnTypeEnum.STRING,
                          TableConfigColumnTypeEnum.INT,
                          TableConfigColumnTypeEnum.MONEY,
                          TableConfigColumnTypeEnum.ARRAY,
                          TableConfigColumnTypeEnum.BOOL,
                          TableConfigColumnTypeEnum.DATE,
                          TableConfigColumnTypeEnum.MULTI_LANGUAGE_ATTRIBUTE_DATA,
                          TableConfigColumnTypeEnum.RESOURCES_SERVICE_PROVIDER_INQUIRY_STATE_MACHINE,
                          TableConfigColumnTypeEnum.EVENTMANAGEMENT_EVENT_REVENUE_COST_CENTER_ENUM,
                          TableConfigColumnTypeEnum.EVENTMANAGEMENT_EVENT_EVENT_STATE_ENUM,
                          TableConfigColumnTypeEnum.EVENTMANAGEMENT_EVENT_EVENT_PHASE_ENUM,
                          TableConfigColumnTypeEnum.RESOURCES_SERVICE_PROVIDER_TYPE_ENUM,
                          TableConfigColumnTypeEnum.RELATION_UUID_ATTRIBUTE_DATA,
                          TableConfigColumnTypeEnum.COUNTRY_CODE_ISO_ALPHA_3_ENUM,
                          ].includes($any(column.type))
                      && ['local', 'local-stage'].includes(environment.env_name)">

              Type not implemented: <code>{{column.type}}</code> (column: {{column | json}})
            </div>


          </div>

        </ng-container>


      </div>
      <div *ngIf="!quickFilterOnly" class="row">
        <div class="col-12 col-sm-6 py-2">
          <button class="btn btn-primary" (click)="resetFilter()">Reset Filter</button>
        </div>
      </div>
    </form>


  </div>


</div>
